import { ScreenContainerControl, } from "doshx_controls_web";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { cancel_basket } from "../../../api/calls/basket/cancel_basket";
import { setBasket } from "../../../reducers/slices/basket/basket";
import { get_basket_thunk } from "../../../reducers/slices/basket/thunks/get_basket_thunk";
import { setMainModal } from "../../../reducers/slices/main";
import { EmptyBasket } from "./empty";
import { PopulatedBasket } from "./populated";
export const BasketPage = () => {
    const dispatch = useDispatch();
    const { basket } = useSelector((state) => state.basketState);
    useEffect(() => {
        // if (!basket) {
        //   navigate("/shop");
        // } else {
        //   dispatch(get_basket_thunk());
        // }
        dispatch(get_basket_thunk());
    }, []);
    useEffect(() => {
        if (basket && basket.product_list.length == 0) {
            cancel_basket({
                _id: basket._id,
            }).then((response) => {
                if (response.success) {
                    dispatch(setBasket(null));
                }
                else {
                    dispatch(setMainModal({
                        title: "Something went wrong!",
                        messages: [response.message],
                    }));
                }
            });
        }
    }, [basket]);
    // const getTotal = (product_list: any[]) => {
    //   let total = 0;
    //   product_list.forEach((product: any) => {
    //     total += parseFloat(product.price) * parseFloat(product.quantity);
    //   });
    //   setProductTotal(total);
    // };
    return (React.createElement("div", { className: "" },
        React.createElement(ScreenContainerControl, { className: "flex flex-col gap-4" }, basket && basket.product_list.length > 0 ? React.createElement(PopulatedBasket, null) : React.createElement(EmptyBasket, null))));
};
